import { Loading } from "../../../../utils/loading";

import { Asset } from "../../../../models/asset";
import { Dealership } from "../../../../models/dealership";

import AssetsAndDriversForm from "./components/assetsAndDriversForm";
import DealershipForm from "./components/dealershipForm";
import DateAndConsultantForm from "./components/dateAndConsultantForm";
import AppointmentSummary from "./components/appointmentSummary";

import { IAssetAndDriverForm, IDateAndConsultantForm, useSchedulingForm } from "../../../../hooks/useSchedulingForm";

import "./styles.scss";

const Appointment = (props: any) => {

  const {
    loading,
    step, setStep,
    assets,
    appointmentForm, setAppointmentForm,
    appointmentId,
  } = useSchedulingForm();

  return (
    <div className="appointment h-full">
      <div className="h-full w-full flex justify-center">
        {
          loading ?
            <Loading label="Carregando dados..." /> :
            <div className="w-full h-full bg-white">
              <div className="stepsSchedule h-full">

                {step === 1 &&
                  <AssetsAndDriversForm
                    setStep={setStep}
                    assets={assets}
                    form={appointmentForm?.assetsAndDrivers}
                    setForm={(form: IAssetAndDriverForm) => setAppointmentForm({ ...appointmentForm, assetsAndDrivers: form })}
                  />
                }

                {step === 2 &&
                  <DealershipForm
                    asset={appointmentForm?.assetsAndDrivers?.asset}
                    setAsset={(asset: Asset) => {
                      setAppointmentForm({
                        ...appointmentForm,
                        assetsAndDrivers: { ...appointmentForm?.assetsAndDrivers, asset }
                      })
                    }}
                    dealership={appointmentForm?.dealership}
                    setDealership={(dealership: Dealership) => setAppointmentForm({ ...appointmentForm, dealership })}
                    setStep={setStep}
                  />
                }

                {step === 3 && (
                  <DateAndConsultantForm
                    dealership={appointmentForm?.dealership}
                    setStep={setStep}
                    form={appointmentForm?.dateAndConsultant}
                    setForm={(form: IDateAndConsultantForm) => setAppointmentForm({ ...appointmentForm, dateAndConsultant: form })}
                    isReschedule={!!appointmentId}
                  />
                )}

                {step === 4 && (
                  <AppointmentSummary
                    appointmentForm={appointmentForm}
                    setStep={setStep}
                    schedulingId={appointmentId}
                  />
                )}
              </div>
            </div>
        }
      </div>
    </div>
  );
};

export default Appointment;